import { render, staticRenderFns } from "./AxMenu.vue?vue&type=template&id=5d702dce&scoped=true&"
import script from "./AxMenu.vue?vue&type=script&lang=ts&"
export * from "./AxMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AxMenu.vue?vue&type=style&index=0&id=5d702dce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d702dce",
  null
  
)

export default component.exports